import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "./Why_Choose_Us.css";
import Common_Headings from "../../common_components/common_heading/Common_Headings";

const Why_Choose_Us = () => {
  const features = [
    {
      id: 1,
      title: "Direct Customer Connection",
      image: "/assets/images/direct-customer-connection.png",
    },
    {
      id: 2,
      title: "No Hidden Charges",
      image: "/assets/images/No-hidden-changes.png",
    },
    {
      id: 3,
      title: "Local Business Growth",
      image: "/assets/images/local-business-growth.png",
    },
    {
      id: 4,
      title: "Verified Vendors & Experts",
      image: "/assets/images/verified-vendor-customer.png",
    },
    {
      id: 5,
      title: "Fast & Easy Communication",
      image: "/assets/images/communication.png",
    },
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <Common_Headings title="WHY CHOOSE US" />

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 2 },
            420: { slidesPerView: 2.5 },
            575: { slidesPerView: 3 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
            1400: { slidesPerView: 5 },
          }}
          className="features-swiper"
        >
          {features.map((feature) => (
            <SwiperSlide key={feature.id}>
              <div className="feature-card">
                <div className="icon-wrapper">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="feature-img"
                  />
                </div>
                <p className="feature-text">{feature.title}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
